import { takeEvery, takeLatest } from 'redux-saga/effects'

import {
  LOGIN,
  INIT_SAGAS,
  LOGOUT,
  FORM_SET_STAGE,
  FINALIZE_FORM,
  FORM_DETAIL,
  FORM_SET_PENDING_FORM,
  FORM_SELECT_POINT,
} from './actions'
import { GET_EXTRAS } from './Controllers/Extras/extras.actions'
import { POINTS_CREATE_CACHE } from './Controllers/Points/points.actions'
import Init from './Controllers/Init/init.saga'
import Auth from './Views/Auth/auth.sagas'
import Form from './Views/Forms/form.saga'
import Extras from './Controllers/Extras/extras.sagas'
import Points from './Controllers/Points/points.sagas'

export default history => function* rootSaga() {
  yield takeEvery(INIT_SAGAS, Init(history, localStorage))
  yield takeEvery(LOGIN, Auth.Login)
  yield takeEvery(LOGOUT, Auth.Logout(history, localStorage))
  yield takeEvery(FORM_SET_STAGE, Form.changeStage)
  yield takeEvery(FINALIZE_FORM, Form.finalize(history))
  yield takeEvery(FORM_DETAIL, Form.getDetail(history))
  yield takeEvery(FORM_SET_PENDING_FORM, Form.continuePendingForm(history))
  yield takeEvery(FORM_SELECT_POINT, Form.onSelectPoint)
  yield takeEvery(GET_EXTRAS, Extras.getExtras)
  yield takeLatest(POINTS_CREATE_CACHE, Points.createCacheAndGoTo)
}
